<template>
  <v-card class="rounded-card">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7">
          <p class="mb-1">
              <span class="headline font-weight-bold text--primary">
                {{ fornecedor.fornecedor.pessoa.nome }}
                <px-open-pagina-fornecedor :id="fornecedor.fornecedor.id"/>
                <px-show-avaliacao-icon-simple class="ml-2"
                                               :avaliacao="pontuacao"/>
              </span>
              <v-chip label v-if="score" class="ml-2">
                <px-fornecedor-score v-if="!loadingScore && score" :score="score"/>
              </v-chip>
            <px-ativo class="ml-2" :ativo="!fornecedor.fornecedor.disabled"/>
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="5" class="text-right">
          <px-fornecedor-edit v-if="hasModuleGerencia"
                              :current-fornecedor="fornecedor"
                              @update="emitUpdate">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
          </px-fornecedor-edit>
        </v-col>
      </v-row>
      <p>
        <v-icon>mdi-domain</v-icon>
        {{ fornecedor.fornecedor.pessoa.cnpj | cnpj }}
        <px-regime-tributario :regime-tributario="fornecedor.fornecedor.pessoa.regimeTributario"/>
      </p>
      <p>
        <v-icon>mdi-map-marker</v-icon>
        {{ fornecedor.fornecedor.endereco | endereco }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import FornecedorEdit from '../edicao/FornecedorEdit.vue';

export default {
  props: {
    fornecedor: Object,
    score: [Object, String],
    loadingScore: Boolean,
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    pontuacao() {
      return this.score ? this.score.pontuacaoMedia : null;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxFornecedorEdit: FornecedorEdit,
  },
};
</script>
